import { requestGet } from '@/common/request';
import { message } from 'antd';
import { LOAD_STATUS } from '@/components/loadable';
import { useEffect, useMemo, useState } from 'react';
import batchedupdates from '@/common/utils/batched-updates';

interface Query {
  channelId: string;
}

interface Result {
  channelId: string;
  channelName: string;
  erp: string;
  realName: string;
  imageUrl: string;
  remark: string;
  display: {
    // 查看管理组
    MANAGER_GROUP_INFO: boolean;
    // 权限管理
    AUTHORITY_MANAGEMENT: boolean;
  };
  tag: number;
}

export type { Result as PlatFormItem };

export default function queryHeader(query: Query): Promise<RequestResult<Result>> {
  return requestGet('/platform/header', query);
}

export function useQueryHeader(query: Query) {
  const [loadStatus, setLoadStatus] = useState(LOAD_STATUS.FIRST);
  const [state, setState] = useState<Result>();

  useEffect(() => {
    if (!query) return;
    let didMount = true;
    setLoadStatus(LOAD_STATUS.ING);
    queryHeader(query)
      .then((res) => {
        if (!didMount) return;

        const { ret, msg } = res || {};
        if (ret !== '0') {
          message.error(msg || '网络异常请稍候~');
          setLoadStatus(LOAD_STATUS.FAILED);
          return;
        } else {
          batchedupdates(() => {
            setState(res?.data);
            setLoadStatus(LOAD_STATUS.SUCCESS);
          });
        }
      })
      .catch((ex) => {
        setLoadStatus(LOAD_STATUS.FAILED);
        console.error(ex);
      });

    return () => {
      didMount = false;
    };
  }, [query]);

  const data = useMemo(() => {
    const loading = loadStatus === LOAD_STATUS.ING || loadStatus === LOAD_STATUS.FIRST;
    return { loading, data: state, loadStatus };
  }, [loadStatus, state]);

  return [data];
}
